import { render, staticRenderFns } from "./AcademyProducts.vue?vue&type=template&id=4707431f&scoped=true"
import script from "./AcademyProducts.vue?vue&type=script&lang=js"
export * from "./AcademyProducts.vue?vue&type=script&lang=js"
import style0 from "./AcademyProducts.vue?vue&type=style&index=0&id=4707431f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4707431f",
  null
  
)

export default component.exports